export enum BrowserEvent {
  UNAUTHORIZED = 'unauthorized-event',
  TOO_MANY_REQUESTS = 'too-many-requests-event',
}
